import { useEffect } from "react";
import {useNavigate, useParams} from "react-router-dom";


const imageContainer = {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    gap: '10px',
}

const headStyle = {
    // display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const yearSelect = {
    width: '90px'
}

const img = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '8px'
}



    const BlankTemplate = ({ user, ...props }) =>
    {
        const navigate = useNavigate();
        const array = [1,2,3,4,5,6,7,8];
        useEffect(() => {
            if (!user) {
                return;
            }
        },[]);

        const handleClick = (path) => {
            window.open(path, "_blank");
        }

       return <div className="right_container">
            <div className="dashboard">
                <div className='inner-content'>
                    <div style={headStyle}>
                        <h1>Blank Template</h1>
                    </div>
                    <div style={imageContainer}>
                        {array?.map((item) => {
                                return <div key={item} onClick={()=>handleClick(`/images/blank${item}.jpg`)} className='media-item'>
                                    <img style={img} src={`../../../../images/blank${item}.jpg`} alt={item} />
                                </div>
                        })}
                    </div>
                </div>
            </div>
        </div>
    }

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};

export default BlankTemplate;